import styled, { css } from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { darken, lighten } from 'polished'
import { Link } from 'gatsby'
import { CenteredOnMobile } from '../Hero/styles'
import { SyncsSection } from '../HomepageCalHero/styles'

export const Section = styled.div`
  position: relative;
`

export const JumbotronImageContainer = styled.div`
  margin-top: 0px;
  > div:first-child {
    display: block;
  }
  > div:nth-child(2) {
    display: none;
  }
  @media (max-width: ${breakpoints.m}px) {
    margin-top: -100px;
    > div:first-child {
      display: none;
    }
    > div:nth-child(2) {
      display: block;
    }
  }
  @media (max-width: 600px) {
    margin-top: -20px;
  }
`

export const ContentContainer = styled.div`
  position: absolute;
  top: 10%;
  left: 5%;
  width: 560px;
  @media (max-width: 1100px) {
    width: 500px;
  }
  @media (max-width: 1400px) {
    width: 450px;
  }
  @media (max-width: ${breakpoints.xl}px) {
    width: 400px;
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 90%;
    margin: auto;
    text-align: center;
    top: 13%;
  }
  @media (max-width: 700px) {
    top: 12%;
  }
  @media (max-width: 600px) {
    top: 10%;
  }
  @media (max-width: ${breakpoints.s}px) {
    top: 10%;
  }
  @media (max-width: 470px) {
    top: 50px;
  }
  @media (max-width: 400px) {
    top: 30px;
  }
`

export const Headline = styled.p`
  color: black;
  font-family: 'FilsonPro';
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: -0.288px;
  margin-bottom: 10px;
  @media (max-width: ${breakpoints.l}px) {
    .yotpo-bottom-line-scroll-panel {
      justify-content: center !important;
    }
  }
  @media (max-width: ${breakpoints.m}px) {
    margin: 0px;
    .yotpo-reviews-star-ratings-widget {
      flex-direction: column !important;
    }
  }
`

export const Title = styled.h1`
  color: ${(props) => props.theme.grayDark};
  font-family: 'FilsonPro';
  font-size: 72px;
  font-style: normal;
  line-height: 111.3%;
  letter-spacing: -0.864px;
  font-weight: 700;
  margin: 0px;
  width: 100%;
  span {
    font-weight: 425;
  }
  @media (max-width: 1400px) {
    font-size: 56px;
  }
  @media (max-width: ${breakpoints.xl}px) {
    font-size: 38px;
  }
  @media (max-width: ${breakpoints.m}px) {
    margin: 0px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 36px;
  }
  @media (max-width: 365px) {
    font-size: 32px;
  }
`

export const Text = styled.p`
  color: ${(props) => props.theme.grayDark};
  font-family: 'FilsonProBook' !important;
  font-size: 22px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 140% !important;
  letter-spacing: -0.24px;
  margin: 0px;
  @media (max-width: ${breakpoints.xl}px) {
    margin: 8px 0px;
    font-size: 20px !important;
  }
  @media (max-width: ${breakpoints.l}px) {
    font-size: 18px !important;
    margin: 0px 0px 16px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px !important;
    padding: 0px 16px;
  }
  @media (max-width: 390px) {
    font-size: 16px !important;
    padding: 0px 0px;
  }
  @media (max-width: 365px) {
    font-size: 15px !important;
  }
`
export const CtaContainer = styled.div`
  display: flex;
  margin-bottom: 32px;
  @media (max-width: ${breakpoints.m}px) {
    justify-content: center;
  }
  @media (max-width: ${breakpoints.s}px) {
    margin: 8px 0px;
    align-items: center;
  }
`

export const CenteredMobile = styled(CenteredOnMobile)`
  position: relative;
  margin-top: 30px;
  @media (max-width: ${breakpoints.l}px) {
    margin-top: 8px;
  }
  @media (max-width: 350px) {
    width: 100%;
  }
`
const linkStyle = css`
  font-family: 'FilsonPro';
  background-color: ${(props) => props.theme.coral};
  color: white;
  text-decoration: none;
  border-radius: 28px;
  border: none;
  font-size: 18px;
  padding: 15px 30px;
  letter-spacing: 0.09px;
  &:hover {
    cursor: pointer;
    background-color: ${(props) => darken(0.1, props.theme.coral)};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.theme.coral)}`};
  }
  @media (max-width: ${breakpoints.m}px) {
    font-size: 16px;
    letter-spacing: 0.08px;
  }
`
export const BuyNowLink = styled(Link)`
  ${linkStyle}
  color: ${(props) => (props.ctacolor ? 'black' : 'white')};
  background-color: ${(props) => (props.ctacolor ? props.ctacolor : props.theme.coral)};
  &:hover {
    cursor: pointer;
    background-color: ${(props) => darken(0.1, props.ctacolor || props.theme.coral)};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.ctacolor || props.theme.coral)}`};
  }
  @media (max-width: 1160px) {
    padding: 15px 30px;
  }
  @media (max-width: ${breakpoints.l}px) {
    font-size: 18px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 18px;
  }
  @media (max-width: 400px) {
    font-size: 18px;
    padding: 15px 30px;
  }
  @media (max-width: 350px) {
    display: inline;
    position: relative;
    z-index: 2;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`
export const Intro = styled.span`
  font-family: 'FilsonPro';
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.484px;
  @media (max-width: ${breakpoints.xl}px) {
    padding: 10px;
    font-size: 18px;
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 100%;
    text-align: center;
  }
  @media (max-width: ${breakpoints.m}px) {
    display: block;
  }
`
export const SyncsSectionContainer = styled(SyncsSection)`
  @media (max-width: ${breakpoints.l}px) {
    justify-content: left;
    align-items: left;
  }
  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`
export const LogoImageContainer = styled.div`
  width: 90px;
  @media (max-width: ${breakpoints.l}px) {
    width: 70px;
  }
  @media (max-width: ${breakpoints.s}px) {
    width: 40px;
  }
  @media (max-width: 365px) {
    margin: 0px -4px;
  }
`
export const MobileSyncsSection = styled.div`
  display: none;
  @media (max-width: ${breakpoints.s}px) {
    display: block;
  }
`
